import { Hero } from './hero/hero';
import { StickyNav } from './sticky-nav/sticky-nav';
import { Contact } from './contact/contact';
import { StyledAppContainer } from './app.styles';
import { PhotoDivider } from './photo-divider/photo-divider';
import { Music } from './music/music';
import { Shows } from './shows/shows';

const App = () => {
  return (
    <StyledAppContainer>
      <StickyNav />
      <Hero />
      <PhotoDivider
        imgSrc="website_divider_1.jpg"
        imgAlt="Mylar balloons in front of a weeping willow tree"
      />
      <Music />
      <PhotoDivider
        imgSrc="website_divider_2.jpg"
        imgAlt="Concrete wall with shadows of a person in a cowboy hat and a bunch of star-shaped balloons"
      />
      <Shows />
      <Contact />
    </StyledAppContainer>
  );
};

export default App;
